<sm-page-header [breadcrumb]="breadcrumb" title="clarification.reports.plural"></sm-page-header>

<div class="card p-4 mt-4">
    <sm-data-table-builder *ngIf="dataTableObject" [dataTableObject]="dataTableObject"
        [datas]="(reports$ | async) || []" [loading]="(loading$ | async) || false"></sm-data-table-builder>
</div>